import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PaginationforProjectRecent from "./PaginationforProjectRecent";
import PaginationforProjectActive from "./PaginationforProjectActive";
import PaginationforProjectCompleted from "./PaginationforProjectCompleted";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import PaginationforProjectCancelled from "./PaginationforProjectCancelled";

export default function PaginationforProjects() {
  const path = "Assets/scss/myorders.module.scss";
  const { urlstate, setMyAllProjectListroute } = useRouteBaseStateContext();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [activeTab, setActiveTab] = useState("paymentpendingprojects"); // State to track active tab
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);



  useEffect(() => {
    dispatch(getPostCounts(2));
  }, [dispatch]);


  useEffect(() => {
    if (urlstate?.myallprojectlistroute) {
      setActiveTab(urlstate?.myallprojectlistroute || "paymentpendingprojects");
    } else {
      setActiveTab("paymentpendingprojects");
    }
  }, [urlstate, urlstate?.myallprojectlistroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyAllProjectListroute(tab);
  };

  return (
    <>
      <div className="order-section manage-project">
        <div className="tab-sec">
          <div className="order-first">
            <h2>My Orders</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("paymentpendingprojects")}
                  className={`nav-link ${activeTab == "paymentpendingprojects" ? "active" : ""}`}
                >
                  Recent Posted Post & Browse Projects (PBP) (
                  {postcounts?.posted_orders?.recent_project || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("activeprojectlist")}
                  className={`nav-link ${activeTab == "activeprojectlist" ? "active" : ""}`}
                >
                  Active Post & Browse Projects (PBP) ({postcounts?.posted_orders?.project || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("active")}
                  className={`nav-link ${activeTab == "active" ? "active" : ""}`}
                >
                  Completed Post & Browse Projects (PBP) (
                  {postcounts?.completed_orders?.project || 0})
                </a>
              </li>
               <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Cancelled")}
                  className={`nav-link ${activeTab == "Cancelled" ? "active" : ""}`}
                >
                  Cancelled Post & Browse Projects (PBP) (
                  {postcounts?.cancelled_orders?.project || 0})
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {activeTab == "paymentpendingprojects" && (
              <div className="tab-pane active" id="paymentpendingprojects">
                <PaginationforProjectRecent />
              </div>
            )}
            {activeTab == "activeprojectlist" && (
              <div className="tab-pane active" id="activeprojectlist">
                <PaginationforProjectActive />
              </div>
            )}
            {activeTab == "active" && (
              <div className="tab-pane active" id="active">
                <PaginationforProjectCompleted />
              </div>
            )}
            {activeTab == "Cancelled" && (
              <div className="tab-pane active" id="Cancelled">
                <PaginationforProjectCancelled />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
